import styled from 'styled-components';
import { SYS_COLOR_TEXT_COPY_DEFAULT_DARK } from '@oneaudi/unified-web-alpha-common';
import { dynamicStylingHelper } from './AlphaHelper';
export const StyleUnstyledHTML = styled.div `
  a,
  a:hover,
  a:active,
  a:focus,
  a:visited {
    color: ${dynamicStylingHelper('#333', SYS_COLOR_TEXT_COPY_DEFAULT_DARK)};
  }
`;
